import { getHumanizedMinValue } from '../../helpers/humanization.js';

const getBukhgalteriyaDlyaBiznesaTerms = item => {
    // Обслуживание, Мобильное приложение
    const conditions = [];
    const prices = { from: item.price, to: item.priceTo };
    conditions.push({
        value: getHumanizedMinValue(prices, ' ₽/мес'),
        description: 'Обслуживание',
        wide: true,
        key: 'obsluzhivanie',
    });
    const mobile = item.dictAdvantages?.includes('mobile');
    conditions.push({ value: mobile ? 'Да' : 'Нет', description: 'Мобильное приложение', key: 'mob-pril' });
    return conditions;
};

export { getBukhgalteriyaDlyaBiznesaTerms };
//# sourceMappingURL=bukhgalteriyaDlyaBiznesa.js.map
